import React, { useCallback, useEffect, useRef, useState } from "react";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import useLocalizedData from "../../../../../../utils/hooks/useLocalizedData";
import { citizenBaseUrl, landUseSubTabLabels, primaryTabLabels, SidebarLabelsLandUse } from "../../../components/data";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { Loader } from "@egovernments/digit-ui-react-components";
import { genderData, landSubUseTypes, landUseList, landUsesSchemeTypeList, landSubUseTypes2 } from "../../../../TCPForms/data";
import { addYearsToIndianDate, filterCategory } from "./helpers";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import { useQuery } from "react-query";
import { convertEpochToDateDMY } from "../../../../../../utils";
import get from "@egovernments/digit-ui-libraries/src/hooks/obps/useFormSubmitValidation";
import useLandUseData from "./useLandUseData";
// import { validateSummaryForm } from "../../../../../utils/summaryFormValidation";
import { validateSummaryForm } from "../../../../../../utils/summaryFormValidation";
const useLandUseLogic = () => {
  const { authority, plan, form, year, serial, formType } = useParams(); //:authority/:plan/:form/:year/:serial
  console.log(useParams(), "paramsHook");
  const tenantId = Digit.ULBService.getStateId() || "up";

  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");

  const id = authority ? `${authority}/${plan}/${form}/${year}/${serial}` : undefined;
  console.log("idFromLogic", id);
  const Modal = useModal();

  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const history = useHistory();

  const { info: userInfo } = Digit.UserService.getUser();
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const [usersData, setUsersData] = useState([]);
  const [validity, setvalidity] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const { documents } = useSelector((state) => state.formMT);
  const userUid = userInfo?.uuid;
  console.log("applicationFlowFromLogic", applicationFlow, userInfo);
  const consultantCategory = filterCategory(userInfo?.roles);
  const useFormSubmitValidation = (validationRules, payload) => {
    console.log("fromFormValidationnnn", validationRules, payload);

    const validate = () => {
      let formIsValid = true;

      // Iterate through validation rules and check conditions
      validationRules.forEach((rule) => {
        const { path, errorMessage, condition = (value) => !value } = rule;
        console.log("pathFromHook", path, errorMessage, condition);

        const value = get(payload, path);

        if (condition(value)) {
          Modal("Validation Error", errorMessage, "error");
          formIsValid = false;
          return; // You can't break out of forEach directly, so return early from the function
        }
      });
      console.log("forIsValidddd", formIsValid);

      return formIsValid; // Return the validity status
    };

    // Call validate() immediately whenever this hook is invoked
    const isValid = validate();
    console.log("majorOutPutFromValidate", isValid);

    return isValid; // Return the current validation status (true or false)
  };
  useEffect(() => {
    const searchUser = async () => {
      try {
        const response = await Digit.UserService.userSearch(tenantId, { uuid: [userUid] }, {});
        console.log("searchUser:", response);
        setUsersData(response?.user);
        if (response?.user?.length > 0) {
          const expiryDate = (response?.user?.[0]?.validUpto).split(" ")[0];
          console.log("expiryDateFromLogic", expiryDate);
          setvalidity(expiryDate);
          // addYearsToIndianDate(expiryDate, 5, setValidity);
        }
      } catch (error) {
        console.error("Error during user search:", error);
      }
    };

    searchUser();
  }, [tenantId, userUid, setvalidity]);
  // const { applicationData, isAppDataLoading } = getLandUseData(id);
  const { applicationData, isAppDataLoading } = useLandUseData({
    id,
    tenantId,
    userInfo,
    usersData,
    applicationFlow,
    validity,
    userUid,
  });
  const summaryRef = useRef();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORMLANDUSE", applicationData);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("LANDUSE_CURRENT_TAB") || 0);
  const [subActiveTab, setSubActiveTab] = useState(Digit?.SessionStorage.get("LANDUSE_CURRENT_SUBTAB") || 0);
  const [showToast, setShowToast] = useState(null);
  const [archData, setArchData] = useState({});
  const isDA = applicationFlow === "DA";

  useEffect(() => {
    if (applicationData && applicationData?.selectedModule) {
      setSelectedModule(applicationData?.selectedModule);
    }
  }, [applicationData]);

  const validationRules = [
    isDA
      ? {
        path: "selectedOffice",
        errorMessage: "Please select verifying authority before submitting.",
        condition: (value) => !value,
      }
      : {
        path: "selectedUnit",
        errorMessage: "Please select unit/city before submitting.",
        condition: (value) => !value,
      },
    {
      path: "landInfo.owners.0.name",
      errorMessage: "Please fill all the mandatory details in owner information tab.",
      condition: (value) => !value,
    },
    {
      path: "professionalInformation.mobileNumber",
      errorMessage: "Please fill all the mandatory details in LTP information tab.",
      condition: (value) => !value,
    },
    {
      path: "descriptionOfLand.schemeType",
      errorMessage: "Please fill all the mandatory details in land information tab.",
      condition: (value) => !value,
    },
    {
      path: "documents.1.fileStoreId",
      errorMessage: "Please upload all the mandatory documents in document tab.",
      condition: (value) => !value,
    },
  ];

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  const handleTabChange = (nextTabNo, formData = null) => {
    console.log("ActiveTab", activeTab, nextTabNo, formData, params);
    if (formData) {
      const data = { ...params, ...formData };

      if (activeTab === 0 && nextTabNo === 1 && !("additionalDetails" in params)) {
        Digit.OBPSService.createLandUseUP({ LandUse: data }, tenantId)
          .then((result) => {
            if (result?.LandUse?.length > 0) {
              onSelect("", { ...data, ...result.LandUse[0] }, true);
              setShowToast({ key: "success", message: `Data has been saved successfully!` });

              setActiveTab(nextTabNo);
              Digit.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
            }
          })
          .catch((e) => {
            setShowToast({ key: "true", error: true, message: e?.response?.data?.Errors[0]?.message });
          });
      } else {
        try {
          if (activeTab === 2 || nextTabNo === 4) {
            console.log("insideActiveTab3", activeTab, nextTabNo);

            // data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
            let redirectUrl = "";
            let message = "";
            const riskType = formData?.riskType;
            const isLowRiskCase = formData?.riskType === "LOW";
            console.log("riskingTypeFrom", riskType, isLowRiskCase);
            const isSchemeType = formData?.descriptionOfLand?.schemeType === "Scheme";
            //  &&
            // formData?.descriptionOfLand?.subLandUseAsPerLayout === "Residential" &&
            // formData?.descriptionOfLand?.landArea <= 2000;
            const isNoc =
              formData?.nocDetails?.additionalApplicantNOC?.length > 0 ||
              (formData?.nocDetails?.applicantNOCData &&
                Object.keys(formData?.nocDetails?.applicantNOCData).some((key) => formData?.nocDetails?.applicantNOCData[key] === true));
            // if (!isLowRiskCase && !isNoc) {
            //   Modal(
            //     "NOC Required",
            //     `Please select NOC in NOC Checlist Tab before submitting.`,
            //     "error"
            //     // `${citizenBaseUrl}/payment/collect/${params?.businessService}/${params?.applicationNumber}/${tenantId}/tenantId=${tenantId}`,
            //     // closeModal
            //   );
            //   return;
            // } else

            if (isLowRiskCase) {
              data.nocDetails = {};
            }
            const validation = validateSummaryForm({
              formType: "FORMLANDUSE",
              formData: data,
              reduxDocuments: documents,
              t,
            });
            if (!validation.isValid) {
              Modal("Missing Mandatory Fields", validation.errorHtml, "error");
              return;
            }

            data.workflow = { action: "APPROVED", assignes: null };
            redirectUrl = "/digit-ui/citizen/profile";
            message = "Application Approved";

            //  else if (isSchemeType && riskType !== "LOW") {
            //   //there will be no such case as of current conditions applied
            //   data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
            //   redirectUrl = "/digit-ui/citizen/profile";
            //   message = "Application Submitted to Department";
            // }
            // else if (!isSchemeType) {
            //   data.workflow = { action: "MAKE_PAYMENT", assignes: null };
            //   redirectUrl = `${citizenBaseUrl}/payment/collect/BPA.LAND_USE_FORM/${params?.applicationNo}/${tenantId}/tenantId=${tenantId}`;
            //   // message = "Application Updated Successfully! Redirecting to the payment page...";
            // }
            console.log("logBeforeLandUSeupdate", data, redirectUrl);

            updateApiCall.mutate(
              { LandUse: data },
              {
                onSuccess: () => {
                  onSelect("", data);
                },
                onError: () => {
                  setShowToast({ error: true, message: `Something went wrong, please try again!` });
                },
              }
            );
            console.log("messageFromLU", message);

            Modal(
              "Data has been saved successfully!",
              `Low risk application <strong>${data?.applicationNo}</strong> approved Successfully!`,
              "success",
              redirectUrl
            );

            //  else if (isSchemeType && riskType !== "LOW") {
            //   Modal(
            //     "Data has been saved successfully!",
            //     `Application <strong>${data?.applicationNo}</strong> submitted successfully!`,
            //     "success",
            //     redirectUrl
            //   );
            // }
            // else if (!isSchemeType) {
            //   Modal(
            //     "Data has been saved successfully!",
            //     `Application <strong>${data?.applicationNo}</strong> submitted successfully, redirecting to payment page.`,
            //     "success",
            //     `${citizenBaseUrl}/payment/collect/BPA.LAND_USE_FORM/${params?.applicationNo}/${tenantId}/tenantId=${tenantId}`
            //   );
            // }

            clearParams();

            Digit?.SessionStorage.del("FORMLANDUSE");
            Digit?.SessionStorage.del("LANDUSE_CURRENT_TAB");
            Digit?.SessionStorage.del("LANDUSE_CURRENT_SUBTAB");
          } else {
            console.log("insideELseACTIVETAB", activeTab, nextTabNo);
            data.workflow = { action: "UPLOAD_DOC", assignes: null };
            updateApiCall.mutate(
              { LandUse: data },
              {
                onSuccess: () => {
                  onSelect("", data);

                  setActiveTab(nextTabNo);
                  Digit?.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
                  setShowToast({ key: "success", message: `Data has been saved successfully!` });
                },

                onError: () => {
                  setShowToast({ error: true, message: `Something went wrong, please try again!` });
                },
              }
            );
          }
        } catch (error) {
          setShowToast({ error: true, message: `Something went wrong, please try again!` });
        }
      }
    } else {
      setActiveTab(nextTabNo);
      Digit?.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    console.log("subTabChange", params, formData);

    if (formData) {
      const data = { ...params, ...formData };
      if (activeTab === 0 && subActiveTab === 0 && !("applicationNo" in params)) {
        console.log("dataFromIf", data);

        Digit.OBPSService.createLandUseUP({ LandUse: data }, tenantId)
          .then((result) => {
            if (result?.LandUse?.length > 0) {
              console.log("landuseResult", result?.LandUse);

              onSelect("", { ...formData, ...result.LandUse[0] }, "", true);
              // Modal("Application created.", `Application Created Successfully!`, "success");
              setShowToast({ key: "success", message: `Application Created Successfully!` });
              setSelectedModule(formData?.selectedModule);
              setSubActiveTab(nextSubTab);
              Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
            }
          })
          .catch((e) => {
            // Modal("Create Error.", `Something went wrong!!`, "error");
            setShowToast({ error: true, message: `Something went wrong!` });
          });
      } else {
        try {
          console.log("insideELse", data);
          data.workflow = { action: "UPLOAD_DOC", assignes: null };

          updateApiCall.mutate(
            { LandUse: data },
            {
              onSuccess: (result) => {
                if (result?.LandUse?.length > 0) {
                  onSelect("", result.LandUse[0]);
                  // Modal("Application updated.", `Application Updated Successfully!`, "success");
                  setShowToast({ key: "success", message: `Data has been saved successfully!` });

                  setSubActiveTab(nextSubTab);
                  Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
                }
              },
              onError: () => {
                // Modal("Update Error1", `Something went wrong!!`, "error");
                setShowToast({ error: true, message: `Something went wrong!` });
              },
            }
          );
        } catch (error) {
          // Modal("Update Error.", `Something went wrong!!`, "error");
          setShowToast({ error: true, message: `Something went wrong!` });
        }
      }
    } else {
      console.log("inElseSubtab", nextSubTab);

      setSubActiveTab(nextSubTab);
      Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const closeModal = () => {
    console.log("triggeredCloseModal");

    clearParams();
    // sessionStorage.clear("Digit.FORM_PURCHASABLE_FAR");
    sessionStorage.removeItem("currentTab");
    sessionStorage.removeItem("currentCity");
    sessionStorage.removeItem("currLocality");
    sessionStorage.removeItem("currVillage");
    setTimeout(() => {
      resetFormMTDocs();
    }, 0);
    setShowToast(null);
  };
  const { data: cities, isLoading } = Digit.Hooks.useTenants();
  const { data: { BPA: { Organizations: departmentList } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [
    "Organizations",
  ]);
  const { data: { BPA: { AVPSchemesUnitData: avpData } = {} } = {}, isLoading: isAvpDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [
    "AVPSchemesUnitData",
  ]);
  const { data: { BPA: { logoStore } = {} } = {}, isLoading: isLogoLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);

  const avpUnits = avpData?.map((item) => {
    return { name: item.Unit, label: item.Unit, value: item.Unit };
  });
  const avpLogo = logoStore?.find((item) => item.code === "up.avp");
  const daLogo = logoStore?.find((item) => item.code === "up.da");
  console.log("logoData", { logoStore, avpLogo, daLogo });
  const {
    data: { LandUseMasterData: { Authorities: schemeTypeData } = {} } = {},
    isLoading: schemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: { PrimaryUseMasterData: { ProposedActivity: nonSchemeTypeData } = {} } = {},
    isLoading: nonSchemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);

  // const getUserInfo = async () => {
  //   if (userUid) {
  //     try {
  //       const usersResponse = await Digit.UserService.userSearch(tenantId, { uuid: [userUid] }, {});
  //       console.log(
  //         "userResponse",
  //         usersResponse?.user[0],
  //         convertEpochToDateDMY(usersResponse?.user?.[0]?.validUpto),
  //         convertEpochToDate(usersResponse?.user?.[0]?.validUpto)
  //       );
  //       setArchData(usersResponse?.user[0]);
  //       const expiryDate = convertEpochToDateDMY(usersResponse?.user?.[0]?.validUpto);

  //       console.log("expiryDateFromLogic", expiryDate);

  //       addYearsToIndianDate(expiryDate, 5, setvalidity);
  //     } catch (error) {
  //       return error;
  //     }
  //   }
  // };

  const avpAuthorityList =
    !isLoading && applicationFlow
      ? cities?.filter((district) => district.code?.includes("up.avp"))?.[0]?.boundary?.filter((ele) => ele.hasOwnProperty("location"))
      : [];
  const daAuthorityList =
    !isLoading && applicationFlow
      ? cities?.filter((district) => district.code?.includes("up.da"))?.[0]?.boundary?.filter((ele) => ele.hasOwnProperty("location"))
      : [];
  function filterOfficeNames(completeList) {
    console.log("completeList", completeList);

    const officeNames = completeList?.map((office) => ({ value: office.name, label: office.name }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  }
  function filterDepartmentsList(completeList) {
    console.log("completeListFromFunc", completeList);

    const officeNames = completeList?.map((office) => ({ value: office.Name, label: office.Name }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  }
  console.log("MDMS_Department_Data", schemeTypeData, nonSchemeTypeData);
  console.log("authoritiesNameMDMS", departmentList);
  const daList = departmentList?.filter((item) => item.Type == "DA");
  const avpList = departmentList?.filter((item) => item.Type == "AVP");
  // const daData = filterDepartmentsList(daList);
  // console.log("daDepartments", daData);
  // const officesList = applicationFlow == "DA" ? filterOfficeNames(daAuthorityList) : filterOfficeNames(avpAuthorityList);
  const officesList = applicationFlow == "DA" ? filterDepartmentsList(daList) : filterDepartmentsList(avpList);
  console.log("fromLandUseLogic", officesList, applicationFlow);

  const closeToast = () => {
    if (showToast.gotoProfile) {
      clearParams();
      sessionStorage.removeItem("currentTab");
      sessionStorage.removeItem("currentCity");
      sessionStorage.removeItem("currLocality");
      sessionStorage.removeItem("currVillage");
      setTimeout(() => {
        resetFormMTDocs();
      }, 0);
      history.push("/digit-ui/citizen/profile");
    }
    setShowToast(null);
  };
  return {
    id,
    Modal,
    dispatch,
    initFormMTDocs,
    resetFormMTDocs,
    t,
    history,
    tenantId,
    userInfo,
    applicationData,
    isAppDataLoading,
    summaryRef,
    params,
    setParams,
    clearParams,
    updateApiCall,
    activeTab,
    setSubActiveTab,
    setActiveTab,
    showToast,
    setShowToast,
    handleTabChange,
    Loader,
    handleSubTabChange,
    applicationFlow,
    officesList,
    subActiveTab,
    archData,
    validity,
    DepartmentSelector,
    usersData,
    landSubUseTypes2,
    closeToast,
    departmentList,
    schemeTypeData,
    nonSchemeTypeData,
    avpList,
    avpData,
    avpUnits,
    // villagesData,
    avpLogo,
    daLogo,
    selectedModule,
    setSelectedModule,
  };
};

export default useLandUseLogic;
